<template>
  <div class="mv-tab">
    <div :class="className">
      <filter-svg-group :icon="content.icon" v-if="content.icon"/>
      <div class="tab-label">{{ $t(content.label) }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent} from 'vue';
import FilterSvgGroup from '@/components/svg/FilterSvgGroup.vue';

export default defineComponent({
  name: 'MvTab',
  components: {
    FilterSvgGroup,
  },
  props: {
    content: {
      default: {
        icon: '',
        label: '',
        value: '',
      }
    },
    selected: {
      default: false
    },
    type: {
      default: 'round'
    }
  },
  setup(props) {
    const className = computed(() => {
      let className = ['mv-tab-row']
      if (props.type) className.push(`mv-tab-type-${props.type}`)
      if (props.selected) className.push('mv-tab-selected')
      return className.join(' ')
    })

    return {
      className,
    }
  }
})
</script>
